import { render } from "./Pagination.vue?vue&type=template&id=1cd2b843&scoped=true&ts=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=1cd2b843&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd2b843"],['__file',"resources/js/vue/components/ui/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cd2b843"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cd2b843', __exports__)) {
    api.reload('1cd2b843', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=1cd2b843&scoped=true&ts=true", () => {
    api.rerender('1cd2b843', render)
  })

}


export default __exports__